import * as Yup from "yup";

export const CREATE_CAMPAIGN_VALIDATION_SCHEMA = Yup.object().shape({
  channel: Yup.string().nullable().required("Canal da campanha inválido"),
  campaignSendingType: Yup.number()
    .nullable()
    .required("Objetivo da campanha inválido"),
  measureCampaign: Yup.number()
    .nullable()
    .oneOf([2, 3, 4])
    .when("campaignSendingType", {
      is: (campaignSendingType) => {
        return campaignSendingType ? campaignSendingType === 2.1 : false;
      },
      then: (schema) => {
        return schema.required("Você precisa escolher o que mensurar");
      },
    }),
  name: Yup.string()
    .nullable()
    .required("Você precisa digitar um nome para a sua campanha"),
  startDate: Yup.date()
    .nullable()
    .required("Você precisa digitar uma data de início para a sua campanha")
    .when(
      "parentCampaignEndDate",
      (parentCampaignEndDate, yup) =>
        parentCampaignEndDate &&
        yup.min(
          parentCampaignEndDate,
          "Data de início precisa ser depois do término da campanha pai."
        )
    ),
  endDate: Yup.date()
    .nullable()
    .required("Você precisa digitar uma data final para a sua campanha"),
  sendDate: Yup.date()
    .nullable()
    .required("Quando a sua campanha será enviada?")
    .when(
      "parentCampaignEndDate",
      (parentCampaignEndDate, yup) =>
        parentCampaignEndDate &&
        yup.min(
          parentCampaignEndDate,
          "Data de envio precisa ser depois do término da campanha pai."
        )
    ),
  // TO SMS
  selectedRecipients: Yup.array()
    .of(Yup.object().shape({ value: Yup.string(), label: Yup.string() }))
    .min(1, "Selecione pelo menos um destinatário")
    .required("Selecione pelo menos um destinatário"),
  message: Yup.string()
    .nullable()
    // is SMS
    .when("channel", {
      is: (channel) => {
        return channel ? channel === "sms" : false;
      },
      then: (schema) => {
        return schema
          .required("Mensagem de texto é obrigatória")
          .max(160, "A mensagem não pode ultrapassar 160 caractéres");
      },
    })
    // is EMAIL
    .when("channel", {
      is: (channel) => {
        return channel ? channel === "email" : false;
      },
      then: (schema) => {
        return schema.required("Você precisa selecionar um template");
      },
    }),
  // TO EMAIL
  nameSender: Yup.string()
    .nullable()
    .when("channel", {
      is: (channel) => {
        return channel ? channel === "email" : false;
      },
      then: (schema) => {
        return schema.required("Digite o nome do remetente");
      },
    }),
  emailSender: Yup.string()
    .nullable()
    .when("channel", {
      is: (channel) => {
        return channel ? channel === "email" : false;
      },
      then: (schema) => {
        return schema
          .matches(
            /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            { excludeEmptyString: true, message: "Digite um email válido" }
          )
          .required("Digite o email do remetente");
      },
    }),
  subject: Yup.string()
    .nullable()
    .when("channel", {
      is: (channel) => {
        return channel ? channel === "email" : false;
      },
      then: (schema) => {
        return schema.required("Digite o assunto do e-mail");
      },
    }),
  // TO WHATSAPP
  whatsAppInstance: Yup.object()
    .nullable()
    .when("channel", {
      is: (channel) => {
        return channel ? channel === "whatsapp" : false;
      },
      then: (schema) => {
        return schema.required("Escolha uma instância de whatsapp");
      },
    }),
  whatsAppInstanceStatus: Yup.boolean().when("channel", {
    is: (channel) => {
      return channel ? channel === "whatsapp" : false;
    },
    then: (schema) => {
      return schema
        .oneOf([true], "A instância precisa estar conectada")
        .required();
    },
  }),
  // TO AUTOMATION
  isAutomation: Yup.boolean(),
  intervalAutomation: Yup.number()
    .nullable()
    .positive("Este número deve ser positivo")
    .integer("Este número deve ser inteiro")
    .when("isAutomation", {
      is: (isAutomation: boolean) => {
        return isAutomation ? isAutomation : false;
      },
      then: (schema: Yup.NumberSchema) => {
        return schema.required("Selecione o intervalo");
      },
    }),
  intervalFrequency: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable()
    .when("isAutomation", {
      is: (isAutomation: boolean) => {
        return isAutomation ? isAutomation : false;
      },
      then: (schema: Yup.AnySchema) => {
        return schema.required("Selecione a frequência desta campanha");
      },
    }),
  whenSendAutomation: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable()
    .when(["isAutomation", "intervalFrequency"], {
      is: (isAutomation: boolean, intervalFrequency: any) => {
        return isAutomation && intervalFrequency
          ? isAutomation &&
              (intervalFrequency.value === "weeks" ||
                intervalFrequency.value === "months")
          : false;
      },
      then: (schema: Yup.AnySchema) => {
        return schema.required("Digite quando enviar");
      },
    }),
  intervalHour: Yup.date()
    .nullable()
    .when("isAutomation", {
      is: (isAutomation: boolean) => {
        return isAutomation ? isAutomation : false;
      },
      then: (schema: Yup.DateSchema) => {
        return schema.required("Digite o horário");
      },
    }),
  typeCampaign: Yup.number()
    .nullable()
    .when("isChild", {
      is: (isChild: boolean) => {
        return isChild ? true : false;
      },
      then: (schema: Yup.AnySchema) => {
        return schema.required("Escolha um público");
      },
    }),
});
